import * as React from 'react'
import { SVGProps } from 'react'

const LUNCUSD = (props: SVGProps<SVGSVGElement>) => (
  <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
    <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
    <g clipPath='url(#clip0_2841_21430)'>
      <path
        d='M22.76 33.4279C23.64 36.6771 26.7846 39.1571 28.3723 39.0587C28.4277 39.0587 34.3969 37.9387 37.6646 32.4679C40.2062 28.2094 39.3446 24.0987 35.8862 24.0063C34.6554 24.0987 21.1169 27.2371 22.76 33.4279Z'
        fill='url(#paint0_linear_2841_21430)'
      />
      <path
        d='M35.56 12.5534C33.3832 10.6971 30.7256 9.49471 27.8942 9.08526C25.0629 8.6758 22.1735 9.076 19.56 10.2396C19.2286 10.3777 18.9059 10.5359 18.5938 10.7134C18.3846 10.8242 18.1692 10.9411 17.9785 11.0642H18.0338C17.4131 11.4891 16.8664 12.013 16.4154 12.615C12.0769 18.3565 26.6615 22.5534 34.4708 22.5658C38.0646 25.1504 39.0738 15.2919 35.56 12.5534Z'
        fill='url(#paint1_linear_2841_21430)'
      />
      <path
        d='M20.4462 12.6707C18.44 15.6923 11.7569 17.8215 10.6554 17.4892L10.7908 17.2123C11.1646 16.4688 11.5945 15.7549 12.0769 15.0769C13.0564 13.7602 14.2285 12.5985 15.5539 11.6307C15.9632 11.3215 16.3884 11.034 16.8277 10.7692C17.5016 10.3839 18.2609 10.1724 19.0369 10.1538C22.0154 10.2092 20.4585 12.6153 20.4462 12.6153'
        fill='url(#paint2_linear_2841_21430)'
      />
      <path
        d='M18.7969 34.0247C18.9446 34.9724 18.7969 38.7201 18.6 39.0401C18.4338 39.0401 18.0892 39.0709 17.08 38.5047C16.5512 38.2042 16.0415 37.8712 15.5538 37.5078C14.8986 37.0223 14.2814 36.4874 13.7077 35.9078C13.1265 35.3356 12.5915 34.7183 12.1077 34.0617C11.1222 32.7247 10.3556 31.2395 9.83692 29.6617C9.56509 28.8593 9.35927 28.036 9.22154 27.2001C8.94255 25.478 8.94255 23.7222 9.22154 22.0001C9.36069 21.1645 9.56648 20.3414 9.83692 19.5386C9.88615 19.3786 9.94154 19.2186 10.0031 19.0586C11.1538 20.5971 12.4646 21.9878 13.6277 23.5386C14.7908 25.0894 16.1938 27.4278 16.4954 27.9447C18.3415 31.1386 18.6738 33.114 18.8154 34.0617'
        fill='url(#paint3_linear_2841_21430)'
      />
      <path
        d='M41 24.5719C41.0021 26.5875 40.6242 28.5855 39.8861 30.4611C38.0031 32.4857 25.2954 27.495 25.1723 27.4396C23.4308 26.6765 18.1446 24.3627 17.6646 20.7073C17 15.4581 27.6031 11.8027 32.2738 11.6611C32.8338 11.6611 34.5385 11.6611 35.5292 12.4981C37.2509 14.0028 38.63 15.8591 39.5738 17.9418C40.5175 20.0245 41.0038 22.2853 41 24.5719Z'
        fill='url(#paint4_linear_2841_21430)'
      />
      <path
        d='M32.3846 38.7872C31 39.4395 29.4738 38.9656 29.8738 37.6118C30.6308 35.021 37.2585 32.3564 38.7415 32.2148C38.92 32.2148 39 32.3195 38.92 32.461C37.39 35.1502 35.1222 37.3454 32.3846 38.7872Z'
        fill='url(#paint5_linear_2841_21430)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_2841_21430'
        x1='30.8769'
        y1='39.0587'
        x2='30.8769'
        y2='24.0063'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#4366C2' />
        <stop offset='0.15' stopColor='#3458B8' />
        <stop offset='0.4' stopColor='#2348AC' />
        <stop offset='0.67' stopColor='#193FA5' />
        <stop offset='1' stopColor='#163CA3' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_2841_21430'
        x1='26.68'
        y1='22.9904'
        x2='26.68'
        y2='8.92267'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#4366C2' />
        <stop offset='0.15' stopColor='#3458B8' />
        <stop offset='0.4' stopColor='#2348AC' />
        <stop offset='0.67' stopColor='#193FA5' />
        <stop offset='1' stopColor='#163CA3' />
      </linearGradient>
      <linearGradient
        id='paint2_linear_2841_21430'
        x1='10.6492'
        y1='13.8584'
        x2='20.8646'
        y2='13.8584'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#58C66B' />
        <stop offset='1' stopColor='#5491F6' />
      </linearGradient>
      <linearGradient
        id='paint3_linear_2841_21430'
        x1='9'
        y1='29.034'
        x2='18.8585'
        y2='29.034'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#58C66B' />
        <stop offset='1' stopColor='#5491F6' />
      </linearGradient>
      <linearGradient
        id='paint4_linear_2841_21430'
        x1='17.6338'
        y1='21.3042'
        x2='41'
        y2='21.3042'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#58C66B' />
        <stop offset='1' stopColor='#5491F6' />
      </linearGradient>
      <linearGradient
        id='paint5_linear_2841_21430'
        x1='29.8185'
        y1='35.6425'
        x2='38.9631'
        y2='35.6425'
        gradientUnits='userSpaceOnUse'>
        <stop stopColor='#58C66B' />
        <stop offset='1' stopColor='#5491F6' />
      </linearGradient>
      <clipPath id='clip0_2841_21430'>
        <rect width='32' height='30.1538' fill='white' transform='translate(9 8.92285)' />
      </clipPath>
    </defs>
  </svg>
)

export default LUNCUSD
